// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"574fe3bf","551":"f08f88f6","629":"a6fc9f5f"}[chunkId] + ".chunk.js";
};